module.exports = __webpack_public_path__ + "261a92146af193f57ff22b52c7fb30f7.svg";